import axios from 'axios';

import { initialize } from 'generated';

export { queryKeys } from 'generated';

const config = initialize(axios);
export const { requests, queries, mutations } = config;
